import { SiteNavigationStyle } from './SiteNavigation.style'
import { SiteNavigationCollapseTabStyle } from './SiteNavigationCollapseTab.style'
import { SiteNavigationTabStyle } from './SiteNavigationTab.style'

export const siteNavigationComponentStyles = {
  components: {
    SiteNavigationStyle,
    SiteNavigationTabStyle,
    SiteNavigationCollapseTabStyle,
  },
}
